import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../utils/firebase/config';

// Función para redimensionar imagen a 512x512
const resizeImage = (file, maxWidth = 512, maxHeight = 512) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;
                
                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                }
                
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                
                canvas.toBlob((blob) => {
                    resolve(new File([blob], file.name, { type: 'image/png' }));
                }, 'image/png');
            };
            
            img.onerror = reject;
        };
        
        reader.onerror = reject;
    });
};

export const uploadImage = async (file, path) => {
    try {
        // Redimensionar imagen antes de subir
        const resizedFile = await resizeImage(file);
        
        const timestamp = Date.now();
        const fileName = `${file.name.split('.')[0]}_${timestamp}_512x512`;
        const storageRef = ref(storage, `${path}/${fileName}`);
        
        const snapshot = await uploadBytes(storageRef, resizedFile);
        const downloadURL = await getDownloadURL(snapshot.ref);
        
        return { success: true, url: downloadURL };
    } catch (error) {
        console.error('Error uploading image:', error);
        return { success: false, error: error.message };
    }
};

export const deleteImage = async (imageUrl) => {
    try {
        const imageRef = ref(storage, imageUrl);
        await deleteObject(imageRef);
        return { success: true };
    } catch (error) {
        console.error('Error deleting image:', error);
        return { success: false, error: error.message };
    }
};
